import React from 'react';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import styles from './CustomMenuButton.module.scss';

type Props = {
  label: string;
  to?: string;
  onClick?: () => void;
  onBlur?: () => void;
  onFocus?: () => void;
  tabIndex?: number;
  active?: boolean;
  startIcon?: React.ReactElement;
  small?: boolean;
} & React.AriaAttributes;

const CustomMenuButton: React.FC<Props> = ({ label, to, onClick, onBlur, onFocus, tabIndex = 0, active = false, startIcon, small = false, ...rest }: Props) => {
  const icon = startIcon ? <div className={styles.startIcon}>{startIcon}</div> : null;

  const buttonClass = classNames(styles.menuButton, {
    [styles.small]: small,
    [styles.active]: active,
  });

  const buttonContent = (
    <>
      {icon}
      <span className={styles.label}>{label}</span>
    </>
  );

  if (to) {
    return (
      <NavLink
        to={to}
        onBlur={onBlur}
        onFocus={onFocus}
        onClick={onClick}
        className={({ isActive }) => classNames(buttonClass, { [styles.active]: isActive })}
        tabIndex={tabIndex}
        end
        {...rest}
      >
        {buttonContent}
      </NavLink>
    );
  }

  return (
    <div role="button" onBlur={onBlur} onFocus={onFocus} onClick={onClick} className={buttonClass} tabIndex={tabIndex} {...rest}>
      {buttonContent}
    </div>
  );
};

export default CustomMenuButton;
